import React from "react";
import Section1 from "../../components/sectionsRgpd/section1";
import Section2 from "../../components/sectionsRgpd/section2";
import Section3 from "../../components/sectionsRgpd/section3";
import Section4 from "../../components/sectionsRgpd/section4";
import Section5 from "../../components/sectionsRgpd/section5";
import Section6 from "../../components/sectionsRgpd/section6";
import Section7 from "../../components/sectionsRgpd/section7";
import Footer from "../../components/sectionsRgpd/footerRgpd";

export default function Rgpd() {
  return (
    <>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Section7 />
      <Footer />
    </>
  );
}
